export const SRC_W = 1569;
export const SRC_H = 1002;
// Hit region: measured from the A/B pixel difference (washer = 670–923 × 273–609) plus a small margin.
// Used ONLY for pointer hit-testing; zoom framing still uses ZOOM_BOX so the trajectory is unchanged.
export const BOX = { x0: 662, x1: 928, y0: 266, y1: 616 };
export const ZOOM_BOX = { x0: 660, x1: 922, y0: 267, y1: 610 };
// Geometry space stays 1569 × 1002; the 4707 × 3006 assets are exactly 3×, so object-cover maps identically.
// Drain pump: normalized source coords (0.563, 0.563) of the full image → geometry space.
export const HOT_NORM = { x: 0.563, y: 0.563 };
export const HOT = { x: HOT_NORM.x * SRC_W, y: HOT_NORM.y * SRC_H }; // ≈ (883.3, 564.1)

export interface Geo {
  w: number;
  h: number;
  s: number;
  ox: number;
  oy: number;
}

// Mirrors object-cover + object-[51%_20%] / md:object-[51%_35%]
export const computeGeo = (w: number, h: number): Geo => {
  const s = Math.max(w / SRC_W, h / SRC_H);
  const py = w >= 768 ? 0.35 : 0.2;
  return { w, h, s, ox: (w - SRC_W * s) * 0.51, oy: (h - SRC_H * s) * py };
};

export const toLocal = (g: Geo, x: number, y: number) => ({ x: g.ox + x * g.s, y: g.oy + y * g.s });

// Zoom target: washer centred in viewport, ~1.65–1.8x, image always still covering the Hero
export const zoomTarget = (g: Geo) => {
  const washerW = (ZOOM_BOX.x1 - ZOOM_BOX.x0) * g.s;
  const scale = Math.min(1.8, Math.max(1.65, 470 / washerW));
  const c = toLocal(g, (ZOOM_BOX.x0 + ZOOM_BOX.x1) / 2, (ZOOM_BOX.y0 + ZOOM_BOX.y1) / 2);
  const clamp = (v: number, lo: number, hi: number) => Math.min(hi, Math.max(lo, v));
  const x = clamp(g.w / 2 - c.x * scale, g.w - g.w * scale, 0);
  const y = clamp(g.h * 0.5 - c.y * scale, g.h - g.h * scale, 0);
  return { scale, x, y };
};